import { Input } from "antd";
import { OfferApiFormEditFormData } from "components/Forms/OfferApiFormEditForm/formSchema";
import { FormCol } from "components/UI/Form/FormCol";
import { FormGrid } from "components/UI/Form/FormGrid";
import { useGeneralForm } from "components/UI/GeneralForm/hooks/useGeneralForm";
import { PartnerSelectSearchable } from "components/UI/Selects/PartnerSelectSearchable/PartnerSelectSearchable.tsx";
import { StatusSelectSearchable } from "components/UI/Selects/StatusSelectSearchable/StatusSelectSearchable.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FormItem } from "react-hook-form-antd";

export const ApiFormExternalFinalPageSection = () => {
    const { t } = usePaldockTranslation("forms.offer-api-form-edit");
    const { control, fieldNames } = useGeneralForm<OfferApiFormEditFormData>();

    const skipInternalLoaderFieldName =
        fieldNames.external_final_page_skip_internal_loader?.name || "external_final_page_skip_internal_loader";
    const includeResultsFieldName =
        fieldNames.external_final_page_include_results_in_redirect?.name ||
        "external_final_page_include_results_in_redirect";

    return (
        <FormCol>
            <FormGrid cols={2}>
                <FormItem
                    control={control}
                    name={fieldNames.external_final_page_active?.name || "external_final_page_active"}
                    label={t("fields.external_final_page.label")}
                >
                    <StatusSelectSearchable />
                </FormItem>
                <FormItem
                    control={control}
                    name={
                        fieldNames.external_final_page_included_user_ids?.name ||
                        "external_final_page_included_user_ids"
                    }
                    label={t("fields.external_final_page_included_users.label")}
                >
                    <PartnerSelectSearchable mode="multiple" allowClear={true} />
                </FormItem>
            </FormGrid>
            <FormGrid cols={2}>
                <FormItem
                    control={control}
                    name={fieldNames.external_final_page_default_url?.name || "external_final_page_default_url"}
                    label={t("fields.external_final_page_default_url.label")}
                >
                    <Input allowClear />
                </FormItem>
                <FormItem
                    control={control}
                    name={
                        fieldNames.external_final_page_excluded_default_final_page_user_ids?.name ||
                        "external_final_page_excluded_default_final_page_user_ids"
                    }
                    label={t("fields.external_final_page_excluded_default_final_page_users.label")}
                >
                    <PartnerSelectSearchable mode="multiple" allowClear={true} />
                </FormItem>
            </FormGrid>
            <FormGrid cols={2}>
                <FormItem
                    control={control}
                    name={skipInternalLoaderFieldName}
                    label={t("fields.external_final_page_skip_internal_loader.label")}
                >
                    <StatusSelectSearchable />
                </FormItem>
                <FormItem
                    control={control}
                    name={includeResultsFieldName}
                    label={t("fields.external_final_page_include_results_in_redirect.label")}
                >
                    <StatusSelectSearchable />
                </FormItem>
            </FormGrid>
        </FormCol>
    );
};
